<template>
  <div class="review-radio-stats">
    <input-group-head
      :label="label"
      :error="error"
      large
    />

    <radio-group
      :value="value"
      :options="options"
      :error-mode="!!error"
      @input="$emit('input', $event)"
      name="size"
    />
  </div>
</template>

<script>
import InputGroupHead from '@kit/input-group-head/input-group-head.vue';

export default {
  name: 'review-radio-stats',

  components: { InputGroupHead },

  props: {
    value:{
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    large: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      error: ''
    };
  },

  computed: {
    valid() {
      return this.checkValid();
    },
  },

  watch: {
    value() {
      if (this.error) {
        this.error = ''
      }
    }
  },

  methods: {
    onInput(val) {
      this.$emit('input', val)
    },
    checkValidOutside() {
      const isValid = this.checkValid();

      if (!this.checkValid()) {
        this.error = this.errorMessage;
      }

      return isValid;
    },
    checkValid() {
      if (this.required && this.value === '') {
        return false;
      }

      return true;
    }
  }
}
</script>

<style lang="scss">
  .review-radio-stats {
    .radio-group .ui-radio {
      margin-top: 24px;
    }
  }
</style>
